<template>
  <v-dialog v-model="dialog" width="600">
    <gg-card>
      <gg-toolbar @close="close">
        Change WP Admin Password
      </gg-toolbar>
      <gg-card-text>
        <v-row>
          <v-col cols="12" class="px-2">
            <p class="mb-0" v-if="installation">
              Change your WordPress admin password for {{ installation.softdomain }}.
            </p>
          </v-col>
          <v-col cols="12" md="5" class="pb-0 px-2">
            <gg-input-label>
              Admin Username
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon color="primary" class="mb-1" small v-on="on">
                    mdi-help-circle
                  </v-icon>
                </template>
                <span>This is your current WP-Admin administrator username.</span>
              </v-tooltip>
            </gg-input-label>
            <gg-text-field
              v-model="admin_username"
              name="Admin Username"
              v-validate="'required'"
              :error-messages="errors.collect('Admin Username')"
            />
          </v-col>
          <v-col cols="12" md="7" class="pb-0 px-2">
            <compact-password
              v-model="admin_password"
              outlined
              charset="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMOPRSTUVWXYZ0123456789_"
              autocomplete="new-password"
              label="New Password"
              v-validate="'required|min:8'"
              data-vv-name="password"
              data-vv-as="Password"
              :error-messages="errors.collect('password')"
              with-generator
            />
          </v-col>
        </v-row>
      </gg-card-text>
      <v-card-actions class="px-5 pt-0 pb-3 justify-content-end">
        <gg-btn secondary @click="close">Cancel</gg-btn>
        <gg-btn :loading="loading" @click="setAdminPassword">Change Password</gg-btn>
      </v-card-actions>
    </gg-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import modalMixin from '@/mixins/modal'
import amapi from '@/api/amapi'
import CompactPassword from '@/components/Common/password/CompactPassword'

export default {
  name: 'AdminPasswordModal',
  mixins: [modalMixin],
  components: { CompactPassword },
  props: {
    installation: {
      type: Object,
      validate (val) {
        return val === null || val.hasOwnProperty('insid')
      }
    }
  },
  data () {
    return {
      admin_username: '',
      admin_password: '',
      loading: false
    }
  },
  methods: {
    ...mapActions({
      reportError: 'reportError',
      reportSuccess: 'reportSuccess'
    }),
    async setAdminPassword () {
      const valid = await this.$validator.validateAll()
      if (!valid) return
      this.loading = true
      const payload = {
        insid: this.installation.insid,
        admin_username: this.admin_username,
        admin_password: this.admin_password,
        save_admin_info: 1
      }
      try {
        const response = await amapi.softaculous_api({
          method: 'wordpress',
          _username: this.$route.query.user,
          payload,
        })
        if (!response.done) {
          throw new Error(response.error[0] ?? 'An error has occurred.')
        }
        this.reportSuccess('Password changed.')
        this.close()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
